import React from "react";
import "../styles/NotFound.css";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useSEO } from '../hooks/useSEO';

const NotFound = () => {
  useSEO({
    title: "404 - Page Not Found | Empower Web",
    description: "The page you're looking for couldn't be found. Return to our homepage or explore our services.",
    canonical: "https://empowerweb.in/404",
    ogTitle: "404 - Page Not Found",
    ogDescription: "Page not found. Return to our homepage.",
    keywords: "404, page not found, error, not found"
  });
  return (
    <>
      <Header />
      <Navbar />
      <div className="nf-page">
        <div className="nf-card">
          <h1 className="nf-title">
            Oops! <span>404</span>
          </h1>

          <h2 className="nf-heading">
            The Page You Were Looking for Doesn’t Exist
          </h2>

          <Link to="/" className="nf-main-btn">
            Back to Home →
          </Link>

          <p className="nf-subheading">
            Below are some useful links to explore:
          </p>

          <div className="nf-links">
            <Link to="/webdevelopment">Web development</Link>
            <Link to="/ui-ux-design-noida">ui ux design noida</Link>
            <Link to="/ai-driven-digital-marketing">
              ai driven digital marketing
            </Link>
            <Link to="/lead-generation-services">
              lead generation services
            </Link>
            <Link to="/about">About</Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NotFound;
